import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { dateDashesSetInstead, mobileHyphensSetInstead, ssnHyphensSetInstead } from 'src/app/core/helpers/app-link'
import { enterAndTabHandler,  shiftTabHandler } from '../helpers/events'
import { inputAreaSetActive } from '../helpers/inputs'
import { isPlatformBrowser } from '@angular/common'

export class FocusOutEventEntity {
  ssnInputId: string
  dobInputId: string
  mobileInputId: string
}

@Injectable({
  providedIn: 'root',
})
export class AccountInputEventsService {
  constructor( @Inject(PLATFORM_ID) private platformId: object) {}

  /**
   * clickout
   * check current clicked element
   * if element parent had active/inactive
   * than go through (almost) all OTHER form inputs and reset them active/inactive
   * else go throght (almost) all form inputs and reset them active/inactive
   *
   * {@link clickoutCloseInputAccount }
   */
  onClickoutResetActiveState = true

  /**
   * mobile enter event
   * {@link AccountInputEventsService.setEventKeysMobileReturn }
   */
  onMobileEnterNext = true

  /**
   * enter / tab desktop move
   * {@link AccountInputEventsService.setEventKeysDesktopTabReturn }
   */
  onDesktopEnterOrTabNext = true

  /**
   * shift + tab desktop reverse move
   * {@link AccountInputEventsService.setEventKeysDesktopShiftTab }
   */
  onDesktopShiftTabPrev = true

  /**
   * on focusout set hyphens on mobile input
   * {@link AccountInputEventsService.setMobileAfterChangeAllHyphens }
   */
  isFocusOutMobileSetHyphens = true

  /**
   * on focusout set hyphens on ssn
   * {@link AccountInputEventsService.setSSNAfterChangeAllHyphens }
   */
  isFocusOutSSNSetHyphens = true

  /**
   * on focusout set dashes on date input
   * {@link setDateAfterChangeAllDashes }
   */
  isFocusOutDateSetDashes = true

  /**
   * on enter in form if not input submit form
   * {@link ModalOptionsFormComponent.enterSubmitonKeydownListener }
   */
  // isEnterSubmit = true

  // isDesktopShiftTabTermsPress = true

  /**
   * on valueChanges add active input area to inputs in list
   * {@link showAllInvalid }
   */
  // isValueChangesSetActiveArea = true

  public setupInputEvents(document: Document, breakpoints: any, inputList: string[]): void {
    this.setEventKeysMobileReturn(document, breakpoints, inputList)
    this.setEventKeysDesktopTabReturn(document, inputList)
    this.setEventKeysDesktopShiftTab(document, inputList)
  }

  public setupFocusOutInputEvents(document: Document, entity: FocusOutEventEntity): void {
    if (entity?.dobInputId) {
      this.setDateAfterChangeAllDashes(entity.dobInputId, document)
    }
    if (entity?.ssnInputId) {
      this.setSSNAfterChangeAllHyphens(entity.ssnInputId, document)
    }
    if (entity?.mobileInputId) {
      this.setMobileAfterChangeAllHyphens(entity.mobileInputId, document)
    }
  }


  /**
   * on focusout set hyphens on mobile input
   */
  private setMobileAfterChangeAllHyphens(inputId: string, document): void {
/*     if (!isPlatformBrowser(this.platformId)) {
      return;
    } */
    if (!this.isFocusOutMobileSetHyphens) { return }
    const inpt = document.getElementById(inputId)
    inpt.addEventListener('focusout', (event: any) => {
      const val = event.target.value
      if (!val || val.length === 0) {
        return
      }
      const newVal = mobileHyphensSetInstead(val)
      if (val !== newVal) {
        event.target.value = newVal
        // that.loanForm.get('mobile').setValue(newVal)
      }
    })
  }


  /**
   * on focusout set hyphens on ssn
   */
  private setSSNAfterChangeAllHyphens(inputId: string, document): void {
/*        if (!isPlatformBrowser(this.platformId)) {
      return;
    } */
    if (!this.isFocusOutSSNSetHyphens) { return }
    const inpt = document.getElementById(inputId)
    inpt.addEventListener('focusout', (event: any) => {
      const val = event.target.value
      if (!val || val.length === 0) {
        return
      }
      const newVal = ssnHyphensSetInstead(val)
      if (val !== newVal) {
        event.target.value = newVal
        // that.loanForm.get('socNumber').setValue(newVal)
      }
    })
  }


  /**
   * on focusout set dashes on date input
   */
  private setDateAfterChangeAllDashes(inputId: string, document): void {
   /*     if (!isPlatformBrowser(this.platformId)) {
      return;
    } */
    if (!this.isFocusOutDateSetDashes) { return }
    const inpt = document.getElementById(inputId)
    inpt.addEventListener('focusout', (event: any) => {
      const val = event.target.value
      if (!val || val.length === 0) {
        return
      }
      const newVal = dateDashesSetInstead(val)
      if (val !== newVal) {
        event.target.value = newVal
        // that.loanForm.get('dateOfBirth').setValue(newVal)
      }
    })
  }

  /**
   * set event to inputs go forward by enter + tab
   *
   * go through all inputs and set keydown events in direct order
   */
  private setEventKeysDesktopTabReturn(document: Document, inputList: string[]): void {
/*     if (!isPlatformBrowser(this.platformId)) {
      return;
    } */
    if (!this.onDesktopEnterOrTabNext) {
      return
    }
    for (let i = 0; i < inputList.length - 1; i++) {
      const currentId = inputList[i]
      const inpt = document.getElementById(currentId)
      if (!inpt) {
        continue
      }
      inpt.addEventListener('keydown', (event) => {
        enterAndTabHandler(document, inputList, event, i)
      })
    }
  }

  /**
   * set mobile Enter event to provided inputs (except last);
   */
  private setEventKeysMobileReturn(
    document: Document,
    breakpoints,
    inputList: string[]
  ): void {

 /*    if (!isPlatformBrowser(this.platformId)) {
      return;
    } */
    if (!breakpoints.extraSmall || !this.onMobileEnterNext) {
      return
    }
    for (let i = 0; i < inputList.length - 1; i++) {
      const currentId = inputList[i]
      const inpt = document.getElementById(currentId)
      if (!inpt) {
        continue
      }
      inpt.addEventListener('keydown', (event) => {
       /*  if (!isPlatformBrowser(this.platformId)) {
          return;
        } */
        if (event.key === 'Enter') {
          // console.log('enter on input event')
          const nextId = inputList[i + 1]
          const el = document.getElementById(nextId)
          if (!el) {
            return
          }
          event.preventDefault()

          el.click()
          inputAreaSetActive(el.parentElement)
        }
      })
    }
  }

  /**
   * just go to state as on shift tab
   *
   * go through all inputs and set
   *
   * keydown events in reverse order
   */
  private setEventKeysDesktopShiftTab(document: Document, inputList: string[]): void {
  /*   if (!isPlatformBrowser(this.platformId)) {
      return;
    } */
    if (!this.onDesktopShiftTabPrev) {
      return
    }
    for (let i = inputList.length - 1; i > 0; i--) {
      const currentId = inputList[i]
      const inpt = document.getElementById(currentId)
      if (!inpt) {
        continue
      }
      inpt.addEventListener('keydown', (event) => {
        shiftTabHandler(document, inputList, event, i)
      })
    }
  }
}
